<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="pre3"></a><a id="page_ix">WOMEN, WORK &amp; THE ART <em>of</em> SAVOIR FAIRE</a><a id="page_x"></a></h1><a id="page_x">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm7_pre3.vue?53e27df9